import { action, observable, computed, runInAction, makeObservable } from 'mobx';
import { get, post } from '@partsbadger/utils';
import { LeadProps, AccountLeadProps, IZohoLeadListStaff as IZohoLead } from '@partsbadger/types';

class Lead {
    isLoading = true;
    lead: LeadProps | null = null;
    account: AccountLeadProps | null = null;
    zoholead: IZohoLead[] | undefined = [];

    constructor() {
        makeObservable(this, {
            // Observables
            lead: observable,
            account: observable,
            zoholead: observable,
            // Actions
            searchLeads: action,
            setLead: action,
            setAccount: action,
            //Computed
            IsLead: computed,
        });
    }

    async searchLeads(params: { search: string }) {
        // Search for leads by email
        this.isLoading = true;
        const data = await post(`/staff/leads/search/`, {
            email: params.search,
        });

        this.isLoading = false;
        this.zoholead = data;
    }
    get IsLead(): boolean {
        return !!this.lead?.lead_zoho_id;
    }

    async setLead(data: LeadProps) {
        data && (this.lead = data);
    }

    async setAccount(data: AccountLeadProps) {
        data && (this.account = data);
    }

    clearLead() {
        this.lead = null;
    }

    async convertLeadToContact(payload = {}) {
        return await post(`/staff/leads/convert-to-contact/`, payload);
    }
}
export const LeadStore = new Lead();
